module.exports = {
      id: "login-facebook-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#login-facebook",
      toString: function () {
        return this.url;
      }
    }